import { render, staticRenderFns } from "./workorder-detail-appointments.vue?vue&type=template&id=4cc35074&"
import script from "./workorder-detail-appointments.vue?vue&type=script&lang=js&"
export * from "./workorder-detail-appointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports